import yourFarms from "./yourGrowers";
import homeScreen from "./homeScreen";
import yourCrews from "./yourCrews";

export default [yourFarms, homeScreen, yourCrews];
